import { useEffect } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useRecoilState } from 'recoil';
import { MINUTE, SECOND } from 'time-constants';

import { apiConfig } from '@constants';
import { onboardingLandingState } from '@store';

import { getDspAccessToken } from '../../helpers/DspAuth';

const getOnboardingLanding = async (retry = false) => {
  const { accessToken, error } = await getDspAccessToken(retry);

  if (error) {
    return error;
  }

  const { data } = await axios
    .get(apiConfig.ONBOARDING_LANDING_URL, {
      headers: {
        'x-access-token': accessToken,
      },
    })
    .catch(onboardingError => (retry ? onboardingError : getOnboardingLanding(true)));

  return formatData(data);
};

const formatData = data => {
  if (data?.channels?.length) {
    const onboarding = data?.channels[0];
    const backgroundImage = onboarding?.wallpaper;
    const formattedData = {
      backgroundImage,
    };

    const blocks = onboarding.story_blocks;

    for (const block of blocks) {
      const type = block.name;
      const headline = block.detail?.headline ?? '';
      const call_to_action = block.detail?.call_to_action ?? '';

      if (block.detail?.body && block.detail.body.length > 0) {
        const body = block.detail.body[0];

        formattedData[type] = { headline, body, call_to_action };
      } else {
        formattedData[type] = { headline, body: '', call_to_action };
      }
    }

    return formattedData;
  }
  return data;
};

export const useGetOnboardingLanding = () => {
  const [state, setState] = useRecoilState(onboardingLandingState);

  const { data, error, isFetched, isLoading } = useQuery('getOnboardingLanding', getOnboardingLanding, {
    refetchOnWindowFocus: false,
    refetchInterval: 5 * MINUTE,
    retryDelay: 5 * SECOND,
  });

  useEffect(() => {
    setState({ data, error, isFetched, isLoading });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, isFetched, isLoading]);

  return state;
};
